export const translationKeys = {
  autoSpin: 'AUTOSPIN',
  PLAY: 'PLAY',
  BET_AMOUNT: 'BET AMOUNT',
  bet: 'BET',
  WIN: 'Win',
  lastResult: 'Last Results',
  buyBonus: 'BUY BONUS',
  balance: 'BALANCE',
  lastWin: 'LAST WIN',
  deposit: 'Deposit',
  freeSpins: 'FREE SPINS',
  multiplier: 'MULTIPLIER',
  reSpinsLeft: 'RESPINS LEFT',
  buyBonusGameTitle: 'BUY BONUS GAME',
  pressToStart: 'PRESS TO START',
  CONGRATULATIONS: 'CONGRATULATIONS',
  bonusGameIsActivated: 'BONUS GAME IS ACTIVATED',
  goodLuck: 'GOOD LUCK!',
  yourBet: 'Your Bet:',
  YOU_HAVE_WON: 'YOU HAVE WON',
  PRESS_ANYWHERE_TO_CONTINUE: 'PRESS ANYWHERE TO CONTINUE',
  MAX_WIN_DESC: 'YOU HAVE REACHED THE MAX LIMIT OF THE GAME',
  INTRODUCTION_GAME_TITLE: 'CRYSTAL_CRUSH',
  INTRODUCTION_GAME_DESCRIPTION: 'ALL_THE_COLORS_ARE_WINNING',
  INTRODUCTION_GAME_MAIN_TITLE: 'INTRODUCTION_GAME_MAIN_TITLE',
  INTRODUCTION_GAME_MAIN_DESCRIPTION: 'GOLD_CRYSTAL_WILL_GUARANTEE_FREE_BONUS_GAME_TICKET_WITH_YOUR_CURRENT_BET',
  INTRODUCTION_GAME_BUY_BONUS_TICKET_TITLE: 'BUY_BONUS_TICKET',
  INTRODUCTION_GAME_BUY_BONUS_TICKET_DESCRIPTION: 'YOU_CAN_BUY_A_BONUS_GAME_TICKET_ANY_TIME',
  INTRODUCTION_GAME_PRE_BONUS_GAME_TITLE: 'PRE_BONUS_GAME',
  INTRODUCTION_GAME_PRE_BONUS_GAME_DESCRIPTION: 'COLLECT_FREE_SPINS_MULTIPLIERS_AND_CRYSTALS_IN_PRE_BONUS_GAME_TO_RAISE_YOUR_CHANCES_IN_BONUS_GAME',
  INTRODUCTION_GAME_BONUS_GAME_TITLE: 'BONUS_GAME',
  INTRODUCTION_GAME_BONUS_GAME_DESCRIPTION: 'WATCH_THE_BONUS_GAME_AND_ENJOY_YOUR_TIME',
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_SPIN: 'INVALID_SPIN',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR ',
  NOT_ENOUGH_MONEY: 'NOT_ENOUGH_MONEY',
  INVALID_OPERATION: 'INVALID_OPERATION',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
  SPIN_NOTFOUND: 'SPIN_NOT_FOUND',
  YOUR_BET_IS_ACCEPTED: 'YOUR_BET_IS_ACCEPTED',
  INVALID_SPIN_COUNT: 'INVALID_SPIN_COUNT',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  GAME_RULES_PARAGRAPH_1: 'THE_GAME_CONSISTS_OF_THE_BASIC_AND_BONUS_ROUNDS',
  GAME_RULES_PARAGRAPH_2: 'THE_MAIN_SCENE_WHEEL_IS_DIVIDED_INTO_64_SECTORS_EACH_SECTOR_HAS_A_STONE_OF_DIFFERENT_COLORS_THAT_HAVE_FIXED_COEFFICIENTS_IN_PARTICULAR',
  GAME_RULES_PARAGRAPH_3: 'TO_PARTICIPATE_IN_THE_GAME_THE_PLAYER_MUST_CHOOSE_ONE_OF_THE_4_COLORS_OFFERED_IN_THE_GAME_YELLOW_GREEN_RED_BLUE_AND_MAKE_A_PARTICIPATION_FEE_BET_WITHIN_THE_AMOUNT_OFFERED_BY_THE_ORGANIZER_AFTER_MAKING_THE_PAYMENT_AND_PRESSING_THE_SPIN_BUTTON_THE_WHEEL_WILL_START_SPINNING_AND_WILL_STOP_AT_ANY_RANDOM_COLOR_FROM_4_OFFERED_COLORS',
  GAME_RULES_PARAGRAPH_4: 'THE_WINNERS_OF_THE_GAME_WILL_BE_THE_PLAYERS_WHO_CORRECTLY_GUESS_THE_COLOR_THAT_THE_WHEEL_WILL_STOP_ON_FOR_EXAMPLE_IF_THE_PLAYER_HAS_MADE_A_PARTICIPATION_FEE_BY_CHOOSING_THE_COLOR_GREEN_AND_THE_WHEEL_HAS_STOPPED_ON_THE_GREEN_COLOR_IN_THE_GAME_THE_PLAYER_WILL_BE_CONSIDERED_A_WINNER_AND_IF_THE_WHEEL_STOPS_ON_THE_RED_OR_ANY_COLOR_OTHER_THAN_GREEN_OR_GOLD_THE_PLAYERS_BET_WILL_BE_CONSIDERED_LOST',
  GAME_RULES_PARAGRAPH_5: 'THE_PAYOUT_IS_CALCULATED_BY_THE_PLAYERS_PARTICIPATION_FEE_BET_MULTIPLIED_BY_THE_CORRESPONDING_CORRECTLY_PREDICTED_ODDS_AND_IS_TRANSFERRED_TO_THE_PLAYERS_SPECIAL_GAME_ACCOUNT',
  GAME_RULES_PARAGRAPH_6: 'IF_THE_WHEEL_STOPS_ON_A_GOLDEN_STONE_THE_PLAYER_GETS_A_CHANCE_TO_MOVE_TO_THE_BONUS_ROUND_WITH_THE_MAIN_ROUND_BET_AMOUNT',
  GAME_RULES_PARAGRAPH_7: 'THE_PLAYER_GETS_THE_OPPORTUNITY_TO_PLAY_IN_THE_BONUS_ROUND_UNTIL_THE_NUMBER_OF_SPINS_PROVIDED_IN_THE_FIRST_PART_OF_THE_BONUS_ROUND_EXPIRES',
  GAME_RULES_PARAGRAPH_8: 'GAME_RULES_PARAGRAPH_8',
  GAME_RULES_CRYSTAL_DESCRIPTION_YELLOW: 'YELLOW_1_PIECES_ODDS_X60',
  GAME_RULES_CRYSTAL_DESCRIPTION_GREEN: 'GREEN_12_PIECES_ODDS_X5',
  GAME_RULES_CRYSTAL_DESCRIPTION_RED: 'RED_20_PIECES_ODDS_X3',
  GAME_RULES_CRYSTAL_DESCRIPTION_BLUE: 'BLUE_30_PIECES_ODDS_X2',
  GAME_RULES_CRYSTAL_DESCRIPTION_GOLD: 'GOLD_1_ITEM_OPPORTUNITY_TO_PARTICIPATE_IN_THE_BONUS_GAME',
  GAME_RULES: 'GAME_RULES',
  GAME_HISTORY: 'GAME_HISTORY',
  GAME_HISTORY_TIME: 'GAME_HISTORY_TIME',
  GAME_HISTORY_BET: 'GAME_HISTORY_BET',
  GAME_HISTORY_WIN_ODD: 'GAME_HISTORY_WIN_ODD',
  GAME_HISTORY_WIN: 'GAME_HISTORY_WIN',
  GAME_HISTORY_BONUS: 'GAME_HISTORY_BONUS',
  PLAY_NOW: 'PLAY_NOW',
};


export const defaultTranslation = {
  [translationKeys.INTRODUCTION_GAME_TITLE]: 'CRYSTAL CRUSH',
  [translationKeys.PLAY_NOW]: 'play now',
  [translationKeys.INTRODUCTION_GAME_DESCRIPTION]: 'All the colors are winning.',
  [translationKeys.INTRODUCTION_GAME_MAIN_TITLE]: 'MAIN GAME',
  [translationKeys.INTRODUCTION_GAME_MAIN_DESCRIPTION]: 'Gold crystal will guarantee free bonus game ticket with your current bet.',
  [translationKeys.INTRODUCTION_GAME_BUY_BONUS_TICKET_TITLE]: 'BUY BONUS TICKET',
  [translationKeys.INTRODUCTION_GAME_BUY_BONUS_TICKET_DESCRIPTION]: 'You can buy a bonus game ticket anytime.',
  [translationKeys.INTRODUCTION_GAME_PRE_BONUS_GAME_TITLE]: 'PRE BONUS GAME',
  [translationKeys.INTRODUCTION_GAME_PRE_BONUS_GAME_DESCRIPTION]: 'Collect free spins, multipliers and crystals in pre bonus game to raise your chances in bonus game.',
  [translationKeys.INTRODUCTION_GAME_BONUS_GAME_TITLE]: 'BONUS GAME',
  [translationKeys.INTRODUCTION_GAME_BONUS_GAME_DESCRIPTION]: 'Watch the bonus game and enjoy you time !',
  [translationKeys.INVALID_TOKEN]: 'INVALID TOKEN',
  [translationKeys.INVALID_SPIN]: 'INVALID SPIN',
  [translationKeys.MONEY_TRANSACTION_ERROR]: 'MONEY TRANSACTION ERROR',
  [translationKeys.NOT_ENOUGH_MONEY]: 'NOT ENOUGH MONEY',
  [translationKeys.INVALID_OPERATION]: 'INVALID OPERATION',
  [translationKeys.SPIN_NOTFOUND]: 'SPIN NOT FOUND',
  [translationKeys.INVALID_SPIN_COUNT]: 'INVALID SPIN COUNT',
  [translationKeys.INVALID_AMOUNT]: 'INVALID AMOUNT',
  [translationKeys.GAME_RULES_PARAGRAPH_1]: 'The game consists of the basic and bonus rounds.',
  [translationKeys.GAME_RULES_PARAGRAPH_2]: 'The main scene wheel is divided into 64 sectors. Each sector has a stone of different colors that have fixed coefficients, in particular:',
  [translationKeys.GAME_RULES_PARAGRAPH_3]: 'To participate in the game, the player must choose one of the 4 colors offered in the game (yellow, green, red, blue) and make a participation fee (bet) within the amount offered by the Organizer. After making the payment and pressing the spin button, the wheel will start spinning and will stop at any color at random.',
  [translationKeys.GAME_RULES_PARAGRAPH_4]: 'The winners of the game will be the Players who correctly guess the color on which the wheel will stop. For example, if the player has made a participation fee by choosing the color green and the wheel has stopped on the green color in the game, the Player will be considered as the winner, and if the wheel stops on the red or any other color other than green or gold, the Player\'s bet will be considered the lost.',
  [translationKeys.GAME_RULES_PARAGRAPH_5]: 'The payout is calculated by the Player\'s participation fee (bet) multiplied by the corresponding correctly predicted odds and is transferred to the player\'s special game account.',
  [translationKeys.GAME_RULES_PARAGRAPH_6]: 'If the wheel stops on a golden stone, the Player gets a chance to move to the bonus round with the main round bet amount.',
  [translationKeys.GAME_RULES_PARAGRAPH_7]: 'The player gets the opportunity to play in the Bonus round until the number of spins provided in the first part of the bonus round expires.',
  [translationKeys.GAME_RULES_CRYSTAL_DESCRIPTION_YELLOW]: 'Yellow-1 piece (coefficient x60)',
  [translationKeys.GAME_RULES_CRYSTAL_DESCRIPTION_GREEN]: 'Green-12 pieces (coefficient x5)',
  [translationKeys.GAME_RULES_CRYSTAL_DESCRIPTION_RED]: 'Red-20 pieces (coefficient x3)',
  [translationKeys.GAME_RULES_CRYSTAL_DESCRIPTION_BLUE]: 'Blue-30 pieces (coefficient x2)',
  [translationKeys.GAME_RULES_CRYSTAL_DESCRIPTION_GOLD]: 'Gold - 1 piece (opportunity to participate in the Bonus game)',
}
